module.exports = __webpack_public_path__ + "logo-dandomain.c80c49dd8008a46cac55ba42fc687afb.png";